import React from 'react';
import {motion} from 'framer-motion';

const OpenKitchen=()=> {
return (
<section className="py-20 px-6 bg-cream">
<div className="max-w-6xl mx-auto">
<div className="grid md:grid-cols-2 gap-12 items-center">
<motion.div initial={{opacity: 0,x: 30}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="relative order-2 md:order-1" >
<img src="https://cdn1.sharemyimage.com/smi/2025/10/27/lavie-view-1.png" alt="La Vie Saigon crafted in view workspace" className="rounded-lg shadow-2xl w-full h-96 object-cover" />
<div className="absolute inset-0 bg-gradient-to-t from-warm-brown/20 to-transparent rounded-lg"></div>
</motion.div>
<motion.div initial={{opacity: 0,x: -30}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.8}} viewport={{once: true}} className="space-y-6 order-1 md:order-2" >
<h2 className="text-4xl md:text-5xl font-playfair text-warm-brown mb-6"> Crafted in View </h2>
<h3 className="text-2xl font-playfair text-warm-brown/90 mb-4"> Every Loaf,Every Cup – Made Before Your Eyes </h3>
<p className="text-lg text-warm-brown/80 leading-relaxed"> At La Vie Saigon,we embrace an open kitchen design where every step of baking is visible. Watch our skilled artisans knead dough,shape croissants,and pull the perfect espresso shot. </p>
<p className="text-lg text-warm-brown/80 leading-relaxed"> The aroma of fresh bread,the rhythmic sound of the mixer,the careful craft of our bakers — all made fresh in front of you. This transparency isn't just about showing our process;it's about sharing our passion. </p>
<p className="text-lg text-warm-brown/80 leading-relaxed"> Come for the coffee,stay for the show. There's something magical about watching your meal come to life,knowing that every ingredient has been carefully selected and every technique has been perfected through years of dedication. </p>
</motion.div>
</div>
</div>
</section>
);};
export default OpenKitchen;